// The entry point. Nothing here but wiring.
//
// `VITE_MOR_API` is a build-time constant, so nothing in the running client can be talked
// into pointing a bearer token at another origin. Empty means same-origin, which is what a
// deployment behind one hostname wants.

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';

import { App } from './App.js';
import { keepSessionFresh } from './clerk.js';
import { initSentry } from './sentry.js';
import './styles.css';

// A no-op unless a DSN was built in — see `sentry.ts`.
initSentry();

// A no-op unless a Clerk publishable key was built in. With one, the vendor's session
// becomes the bearer token, kept fresh in `session.ts` — see `clerk.ts`.
keepSessionFresh();

const root = document.getElementById('root');
if (root === null) {
  throw new Error('no #root');
}

createRoot(root).render(
  <StrictMode>
    <Sentry.ErrorBoundary
      fallback={<p className="note">Something went wrong. Reload the page.</p>}
    >
      <BrowserRouter>
        <App baseUrl={import.meta.env['VITE_MOR_API'] ?? ''} />
      </BrowserRouter>
    </Sentry.ErrorBoundary>
  </StrictMode>,
);
